import { z } from "zod";

/** Couleur hex (#RGB ou #RRGGBB) pour la vitrine. */
export const StorefrontHexColorSchema = z
  .string()
  .regex(/^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/)
  .optional();

export type StorefrontHexColor = z.infer<typeof StorefrontHexColorSchema>;

export const normalizeStorefrontHexColor = (
  value?: string | null,
): string | undefined => {
  const trimmed = value?.trim();
  if (!trimmed) return undefined;
  return StorefrontHexColorSchema.safeParse(trimmed).success
    ? trimmed
    : undefined;
};
